import React, { useState } from 'react';
import './ContactUs.css';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import { FaInstagram, FaFacebook, FaTwitter, FaLinkedin, FaPodcast } from 'react-icons/fa';
import Footer from '../Footer';

const WEB3FORMS_KEY = '00bb38f1-38dc-4c70-b5ef-0867572bd0da';

const SOCIALS = [
  { icon: <FaInstagram />, href: 'https://www.instagram.com/theecitychurch/', label: 'Instagram' },
  { icon: <FaFacebook />, href: 'https://www.facebook.com/TheeCityChurch', label: 'Facebook' },
  { icon: <FaTwitter />, href: 'https://x.com/TheCityChurchL/', label: 'Twitter / X' },
  { icon: <FaLinkedin />, href: 'https://www.linkedin.com/company/the-city-church-luzira/', label: 'LinkedIn' },
  { icon: <FaPodcast />, href: 'https://theecitychurchluzira.podbean.com/', label: 'Podcast' },
];

const DETAILS = [
  { icon: <FaPhone aria-hidden="true" />, k: 'Phone', v: '+256 704 083043', href: 'tel:+256704083043' },
  { icon: <FaEnvelope aria-hidden="true" />, k: 'Email', v: 'info@thecitychurch.or.ug', href: 'mailto:info@thecitychurch.or.ug' },
  { icon: <FaMapMarkerAlt aria-hidden="true" />, k: 'Address', v: 'Luzira, Kampala, Uganda', href: null },
];

function ContactUs() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState({ state: 'idle', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ state: 'submitting', message: '' });
    const payload = new FormData();
    payload.append('access_key', WEB3FORMS_KEY);
    payload.append('subject', 'New Contact Message for The City Church');
    payload.append('name', form.name);
    payload.append('email', form.email);
    payload.append('message', form.message);

    try {
      const res = await fetch('https://api.web3forms.com/submit', { method: 'POST', body: payload });
      const result = await res.json();
      if (result.success) {
        setStatus({ state: 'success', message: "Thank you! We’ve received your message and will be in touch soon." });
        setForm({ name: '', email: '', message: '' });
      } else {
        setStatus({ state: 'error', message: 'Something went wrong. Please try again.' });
      }
    } catch {
      setStatus({ state: 'error', message: 'We couldn’t send your message. Please check your connection and try again.' });
    }
  };

  const submitting = status.state === 'submitting';

  return (
    <div>
      {/* HERO */}
      <header className="contact-hero">
        <div className="tcc-container contact-hero__inner">
          <p className="tcc-eyebrow contact-hero__eyebrow">Get in touch</p>
          <h1 className="contact-hero__title">We&rsquo;d love to hear from you</h1>
          <p className="contact-hero__lead">
            Have a question, or want to know more about life at The City Church? Reach out.
            No question is too big or too small, and we are here for you.
          </p>
        </div>
      </header>

      {/* MAIN */}
      <section className="tcc-section contact">
        <div className="tcc-container contact__grid">
          {/* Info */}
          <div className="contact__info">
            <p className="tcc-eyebrow">Ways to reach us</p>
            <h2 className="tcc-h2 contact__title">Come as you are</h2>
            <p className="contact__desc">
              Call, email or drop by on a Sunday. However you prefer to connect, we will
              make sure you are looked after.
            </p>

            <ul className="contact__details">
              {DETAILS.map((d) => (
                <li className="contact__detail" key={d.k}>
                  <span className="contact__ico">{d.icon}</span>
                  <div>
                    <span className="contact__k">{d.k}</span>
                    {d.href
                      ? <a href={d.href}>{d.v}</a>
                      : <span className="contact__v">{d.v}</span>}
                  </div>
                </li>
              ))}
            </ul>

            <div className="contact__social">
              <span className="contact__k">Follow us</span>
              <div className="contact__social-row">
                {SOCIALS.map((s) => (
                  <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}>
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="contact__form-wrap tcc-card">
            <h2 className="contact__form-title">Send us a message</h2>

            {status.state === 'success' && (
              <div className="tcc-alert tcc-alert--success" role="status">{status.message}</div>
            )}
            {status.state === 'error' && (
              <div className="tcc-alert tcc-alert--error" role="alert">{status.message}</div>
            )}

            <form onSubmit={handleSubmit} noValidate>
              <div className="tcc-field">
                <label className="tcc-label" htmlFor="c-name">Name</label>
                <input className="tcc-input" id="c-name" name="name" value={form.name} onChange={handleChange} placeholder="Your name" autoComplete="name" required />
              </div>
              <div className="tcc-field">
                <label className="tcc-label" htmlFor="c-email">Email</label>
                <input className="tcc-input" id="c-email" type="email" name="email" value={form.email} onChange={handleChange} placeholder="you@example.com" autoComplete="email" required />
              </div>
              <div className="tcc-field">
                <label className="tcc-label" htmlFor="c-message">Message</label>
                <textarea className="tcc-textarea" id="c-message" name="message" value={form.message} onChange={handleChange} placeholder="How can we help?" required />
              </div>
              <button type="submit" className="tcc-btn tcc-btn--accent tcc-btn--lg tcc-btn--block" disabled={submitting}>
                {submitting ? (<><span className="tcc-spinner" aria-hidden="true" /> Sending&hellip;</>) : (<>Send message <FaArrowRight aria-hidden="true" /></>)}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* MAP */}
      <section className="contact-map" aria-label="Map to The City Church, Luzira">
        <iframe
          title="Map showing The City Church, Luzira, Kampala"
          src="https://www.google.com/maps?q=The%20City%20Church%20Luzira%2C%20Kampala&output=embed"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </section>

      <Footer />
    </div>
  );
}

export default ContactUs;
